module.exports = require("./ceb.d.ts");